export default "__VITE_ASSET__BS9se1n3__"